import React from 'react';
import PropTypes from 'prop-types';
import Icon from '@welldev-group/rcl-icon';

const ExchangeCartRouteTitle = ({ trips }) => (
  <div className="d-flex-column row-gap-4">
    {trips.map(({ id, originCode, destinationCode }) => (
      <div className="d-flex align-center column-gap-8" key={id}>
        <span>{originCode}</span>
        <Icon name="arrowUp" rotate={90} />
        <span>{destinationCode}</span>
      </div>
    ))}
  </div>
);

ExchangeCartRouteTitle.propTypes = {
  trips: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      originCode: PropTypes.string,
      destinationCode: PropTypes.string,
    }),
  ).isRequired,
};

export default ExchangeCartRouteTitle;
